<template>
    <div class="card-join-internship">
        <div class="card-join-internship__row">
            <div class="card-join-internship__image-wrapper">
                <img
                    v-if="internship.bannerSmall || internship.banner"
                    class="card-join-internship__image"
                    :src="internship.bannerSmall || internship.banner"
                    :alt="internship.title"
                />
            </div>
            <b class="card-join-internship__title">{{ internship.name }}</b>
        </div>
        <div class="card-join-internship__row">
            <button class="card-join-internship__button" @click="goToInternship">Подать заявку</button>
            <div class="card-join-internship__icon">
                <IconInternship />
            </div>
        </div>
    </div>
</template>

<script>
import IconInternship from '@/views/track/icons/IconInternship.vue';

export default {
    name: 'CardJoinInternship',
    components: {
        IconInternship,
    },
    props: {
        internship: {
            type: Object,
            required: true,
        },
    },
    methods: {
        goToInternship() {
            window.open(`https://project.${window.rsvDomain}/${this.internship.projectId}`, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.card-join-internship {
    width: 100%;
    min-height: urem(150);
    background: #fff;
    border-radius: urem(16);
    padding: urem(16);
    box-shadow: 0 urem(2) urem(16) 0 rgba(70, 99, 171, 0.16);
    font-family: $font-montserrat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    * {
        font-family: inherit;
    }

    &__row {
        display: flex;
        align-items: center;
        align-content: center;
    }

    &__image-wrapper {
        width: urem(104);
        height: urem(60);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: urem(16);
        flex-shrink: 0;
        border-radius: urem(10);
    }

    &__image {
        width: 100%;
        height: auto;
        object-fit: scale-down;
        border-radius: urem(10);
    }

    &__title {
        font-size: urem(14);
        font-weight: 600;
        line-height: urem(20);
        color: #251f45;
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        line-clamp: 3;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    &__button {
        width: 100%;
        padding: 0;
        height: urem(42);
        background: none;
        color: #4663ab;
        border: urem(1) solid #4663ab;
        border-radius: urem(10);
        font-size: urem(14);
        font-weight: 600;
        line-height: urem(42);
        cursor: pointer;
        margin-right: urem(24);
    }

    &__icon {
        width: urem(42);
        height: urem(42);
        border-radius: urem(10);
        background-color: #f8dda7;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        svg {
            width: urem(24);
            height: urem(24);
        }
    }
}
</style>
